import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const userData = await login(email, password);
      setIsLoading(false);

      if (userData.role === "admin") {
        navigate("/admin/saques");
      } else {
        navigate("/offers");
      }
    } catch (err) {
      setIsLoading(false);
      setError(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-r from-[#020C24] via-[#020C24] to-[#015FFF]">
      <div className="bg-white shadow p-6 md:p-8 rounded-lg max-w-md w-full">
        <h1 className="text-2xl font-bold mb-4 text-center">Login</h1>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}

        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="block mb-2">Email</label>
            <input
              type="email"
              className="w-full p-3 border rounded"
              placeholder="Digite seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block mb-2">Senha</label>
            <input
              type={showPassword ? "text" : "password"}
              className="w-full p-3 border rounded"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <div className="flex items-center mt-2">
              <input
                type="checkbox"
                className="mr-2"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              />
              <label>Mostrar senha</label>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full p-3 rounded-full transition ${
              isLoading ? "bg-gray-500" : "bg-gray-700 hover:bg-gray-800"
            } text-white`}
          >
            {isLoading ? "Carregando..." : "Entrar"}
          </button>
        </form>

        <p className="text-center text-sm mt-6">
          Ainda não possui cadastro?{" "}
          <Link to="/register" className="text-blue-600 hover:underline font-medium">
            Clique aqui
          </Link>
        </p>

        <p className="text-center text-sm mt-4">
          Esqueceu sua senha?{" "}
          <Link to="/reset-password" className="text-blue-600 hover:underline font-medium">
            Clique aqui para redefinir!
          </Link>
        </p>
      </div>
    </div>
  );
}



